import { ref, onMounted } from 'vue';

import { getLayouts } from '@/api/layouts';

export const useGetLayouts = () => {
  const layouts = ref([]);

  const fetchLayouts = async () => {
    const fetchedLayouts = await getLayouts();
    layouts.value = fetchedLayouts.data;
  };

  onMounted(fetchLayouts);

  return { layouts };
};
